import styled from 'styled-components'

export const Wrap = styled.div`
  width: 100%;
  max-width: 1574px;
  margin: 0 auto;
  padding: 130px 20px 20px;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
`

export const TopBar = styled.div`
  width: 100%;
  max-width: 1574px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
`

export const BackBtn = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.12);
  transition: background 0.2s;
  &:hover { background: rgba(255, 255, 255, 0.15); }
`

export const Controls = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const ControlBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.12);
  color: #fff;
  cursor: pointer;
  transition: background 0.2s;
  &:hover { background: rgba(255, 255, 255, 0.15); }
`

export const GameFrame = styled.iframe`
  width: 100%;
  max-width: 1574px;
  flex: 1;
  border: none;
  border-radius: 15px;
  background: #000;
  box-shadow: 0 4px 20px rgba(20, 184, 166, 0.15);
`

export const PlaceholderBox = styled.div`
  width: 100%;
  max-width: 1574px;
  flex: 1;
  border-radius: 15px;
  background: #000;
  box-shadow: 0 4px 20px rgba(20, 184, 166, 0.15);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  color: #fff;

  p {
    font-size: 16px;
    opacity: 0.8;
  }

  button {
    padding: 14px 28px;
    border-radius: 10px;
    background: #14b8a6;
    color: #fff;
    font-size: 15px;
    font-weight: 600;
    border: none;
    cursor: pointer;
    transition: background 0.2s, transform 0.1s;
    &:hover { background: #0d9488; }
    &:active { transform: scale(0.98); }
  }
`
